export enum ActivationStep {
    Code = 1,
    Password = 2,
    Security = 3,
    Success = 4,
}
